import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const AvailabilityPage = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./tabs')).AvailabilityPageTabs })
  )
)
